import React from 'react';
import Slider from 'react-slick';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as NoImage } from '../../assets/img/icons/common/NoImage.svg';
import { ReactComponent as ChevroneLeft } from '../../assets/img/icons/common/ChevroneLeft.svg';
import { ReactComponent as ChevroneRight } from '../../assets/img/icons/common/ChevroneRight.svg';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './ImageGallery.scss';

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <button
      className="custom-arrow prev-arrow"
      onClick={onClick}
    >
      <ChevroneLeft />
    </button>
  );
}

function NextArrow(props) {
  const { onClick } = props;
  return (
    <button
      className="custom-arrow next-arrow"
      onClick={onClick}
    >
      <ChevroneRight />
    </button>
  );
}

export const ImageGallery = ({ images }) => {
  const settings = {
    customPaging: index => {
      return (
        <a>
          {images[index].loading && (
            <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-50">
              <FontAwesomeIcon icon={faSpinner} spin />
            </div>
          )}

          {images[index].error && (
            <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-50">
              <NoImage width={20} height={20} />
            </div>
          )}

          {images[index].src && (
            <img src={images[index].src} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          )}
        </a>
      );
    },
    dots: true,
    dotsClass: 'slick-dots custom-thumbnails',
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  return (
    <div className="gallery-container">
      <Slider {...settings}>
        {images.map((image, i) => (
          <div key={i} className="main-slide">
            <img src={image.src} />
          </div>
        ))}
      </Slider>
    </div>
  );
};
